<template>
  <div class="itemPage">
    <a
      class="itemBox"
      :class="{
        itemBox__marginRight: index % 3 !== 2,
        itemBox__marginTop: index > 2
      }"
      v-for="(item, index) in data"
      :key="index"
      @click="chooseItem(index)"
    >
      <div class="boxImg">
        <img :src="'http://122.112.172.47/imgs/' + item.coverPic" />
      </div>
      <div class="boxTitle">{{ item.title }}</div>
      <div class="boxTime">{{ item.publishTime }}</div>
      <!--<div class="boxDesc">-->
      <!--{{ item.desc }}-->
      <!--</div>-->
    </a>
  </div>
</template>

<script>
export default {
  name: "CellIcon",
  props: ["data"],
  methods: {
    chooseItem(index) {
      this.$emit("chooseItem", index);
    }
  }
};
</script>

<style scoped>
.itemPage {
  display: flex;
  justify-content: start;
  flex-direction: row;
  flex-wrap: wrap;
  padding-left: 10px;
  margin-bottom: 40px;
}
.itemBox {
  font-family: Source Han Sans CN;
  padding: 20px;
  width: 310px;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid #f1f5f7;
}
.itemBox:hover {
  background-color: #f1f5f7;
}
.itemBox .boxImg {
  border-radius: 10px;
}

.itemBox .boxImg img {
  width: 100%;
}

.itemBox .boxTitle {
  font-size: 18px;
  font-weight: bold;
  color: rgba(24, 24, 24, 1);
  height: 48px;
  line-height: 24px;
  margin: 10px 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*white-space: nowrap;*/
}
.itemBox .boxTime {
  font-size: 14px;
  color: #b1b1b1;
}
.itemBox .boxDesc {
  font-size: 16px;
  width: 100%;
  font-weight: 400;
  color: rgba(24, 24, 24, 1);
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  height: 72px;
}

.itemBox__marginRight {
  margin-right: 20px;
}

.itemBox__marginTop {
  margin-top: 30px;
}
</style>
